// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"-YkIRt551lD5mlQSyS4VY","modalDialog":"_1VRLvf1mggBzKu0iyyzH7K","btn-cancel":"qZvwSy0xa4gHNzkabaA2B","btn-save":"_2f4gASGXLZK-EeyC1z1_Yx"};